const values = {
    "NO_ARTICLE_WAREHOUSES_TITLE": "No hay almacenes de artículos!!!",
    "NEW_ARTICLE_WAREHOUSE": "Nuevo Almacén",
    "EDIT_ARTICLE_WAREHOUSE": "Editar Almacén",
    "ARTICLE_WAREHOUSE_SINGULAR": "Almacén",
    "SELECT_ARTICLE_WAREHOUSE_PLACEHOLDER": "Seleccione Almacén",
    "ARTICLE_WAREHOUSE_FILTER_PLACEHOLDER": "Nombre del almacén",
    "TRANSFER_ARTICLE_TO_WAREHOUSE": "Transferir para almacén",
}

export default values;